export const LOCAL_UNITY_BUILD_PREFIX = "/webplayer/10kScienceWeb_1.2.40p6_Production";

export const PROD_UNITY_BUILD_MANIFEST_URL =
  "https://d1jgo5rdg5ih2b.cloudfront.net/manifests/10kScience/prod/web/latest.json";

export const STAGING_UNITY_BUILD_MANIFEST_URL =
  "https://drhosl982rq5b.cloudfront.net/manifests/10kScience/staging/web/latest.json";
